import { Injectable } from '@angular/core';

import { ProductService } from 'src/app/shared/services/product/product.service';
import { DidYouForgetService } from './did-you-forget.service';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CART_SELECTORS } from '@usf/ngrx-order';
import { combineLatest, Observable, of } from 'rxjs';
import { selectMerchZoneProductNumbers } from '@order/selectors/merch-zone/merch-zone.selectors';
import { selectInspiredPickProductNumbers } from '@order/selectors/inspired-picks/inspired-picks.selectors';

@Injectable({
  providedIn: 'root',
})
export class DYFResolverService {
  constructor(
    private productService: ProductService,
    private didYouForgetService: DidYouForgetService,
    private store: Store,
  ) {}

  resolve(): any {
    const dyfProducts$ = this.didYouForgetService.getDyfProductNumbers$();

    const inspiredPicks$ = this.store.select(selectInspiredPickProductNumbers);

    const merchZoneProductNumbers$ = this.store.select(
      selectMerchZoneProductNumbers,
    );
    const productsForOrder$ = this.store.select(CART_SELECTORS.selectCart).pipe(
      filter(
        cartState => !cartState.loading && cartState.orderItems.length > 0,
      ),
      map(cartState => {
        const productNumbers = cartState.orderItems.map(
          item => item.productNumber,
        );
        return productNumbers;
      }),
    );

    // Now that we know dyfProduct and orderHeader states
    // are populated, call for products
    // also allow for inspired picks to be turned off and on without
    // preventing the page from loading
    combineLatest([
      dyfProducts$,
      inspiredPicks$,
      merchZoneProductNumbers$,
      productsForOrder$,
    ]).subscribe(
      ([
        dyfProductNumbers,
        inspiredProductNumbers,
        merchZoneProductNumbers,
        productsForOrder,
      ]) => {
        const allProductNumbers = [
          ...dyfProductNumbers,
          ...inspiredProductNumbers,
          ...merchZoneProductNumbers,
          ...productsForOrder,
        ];

        const uniqueProductNumbers = Array.from(new Set(allProductNumbers));

        this.productService.loadProducts(uniqueProductNumbers);
      },
    );
  }
}
